import { render } from "./index.vue?vue&type=template&id=96fe4344&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=96fe4344&scoped=true&lang=css"

import exportComponent from "E:\\wwwroot\\FHTMS-work\\fh-vue-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96fe4344"]])

export default __exports__